// extracted by mini-css-extract-plugin
export var body = "bP_c";
export var button = "bP_cf";
export var close = "bP_F";
export var container = "bP_b";
export var content = "bP_b8";
export var heading = "bP_G";
export var link = "bP_bx";
export var mobileHide = "bP_hH";
export var open = "bP_bf";
export var section = "bP_d";
export var show = "bP_L";
export var title = "bP_h";